import styled from "styled-components"

export const Root = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
`

export const TripTargetInfo = styled.div`
  display: flex;
  align-items: center;
`
